import * as React from 'react';
import { GlobalVariables } from '../GlobalVariables';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { ReduxUpdater } from '../redux/ReduxUpdater';
import { GlobalConstants } from '../GlobalConstants';

const LoginForm: React.FC = () => {
    const [email, setEmail] = React.useState('');
    const [password, setPassword] = React.useState('');
    const navigate = useNavigate();

    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50">
            <div className="w-full max-w-md p-6 bg-white border border-gray-200 rounded-2xl shadow-sm sm:p-8">
                <h2 className="text-2xl font-bold text-gray-800 mb-6 text-center">
                    Sign in to your account
                </h2>

                <form className="space-y-5">
                {/* Email */}
                <div>
                    <label
                        htmlFor="email"
                        className="block text-sm mb-2 text-gray-700 font-medium"
                    >
                        Phone Number or Email address
                    </label>
                    <input
                        type="email"
                        id="email"
                        placeholder="Phone or Email"
                        className="py-2 px-3 block w-full border border-gray-300 rounded-lg text-sm focus:border-blue-500 focus:ring-blue-500"
                        onChange={(e) => setEmail(e.currentTarget.value)}
                    />
                </div>

                {/* Password */}
                <div>
                    <label
                        htmlFor="password"
                        className="block text-sm mb-2 text-gray-700 font-medium"
                    >
                        Password
                    </label>
                    <input
                        type="password"
                        id="password"
                        placeholder="••••••••"
                        className="py-2 px-3 block w-full border border-gray-300 rounded-lg text-sm focus:border-blue-500 focus:ring-blue-500"
                        onChange={(e) => setPassword(e.currentTarget.value)}
                    />
                </div>

                    {/* Remember + Forgot */}
                    {/* <div className="flex items-center justify-between">
                        <label className="flex items-center">
                            <input
                                type="checkbox"
                                className="shrink-0 mt-0.5 border-gray-300 rounded text-blue-600 focus:ring-blue-500"
                            />
                            <span className="ml-2 text-sm text-gray-600">Remember me</span>
                        </label>
                        <a
                            href="#"
                            className="text-sm font-medium text-blue-600 hover:underline"
                        >
                            Forgot password?
                        </a>
                    </div> */}

                    {/* Submit */}
                    <button
                        type="submit"
                        className="w-full py-2 px-4 text-white font-medium rounded-lg bg-blue-600 hover:bg-blue-700 focus:ring-2 focus:ring-blue-500"
                        onClick={(e) => {
                            e.preventDefault();
                            console.log('logging in...');
                            GlobalVariables.handleLogin(
                                email,
                                password,
                                () => {
                                    console.log('done...');
                                    navigate([GlobalConstants.UserRole.STANDARD, GlobalConstants.UserRole.BASIC].includes(ReduxUpdater.authenticatedUser?.user_role ?? '') ? '/expenses' : '/fleet', {
                                        replace: true
                                    });
                                },
                                (err) => {
                                    console.log('err...');
                                    toast.error(err);
                                }
                            );
                        }}
                    >
                        Sign in
                    </button>
                </form>

                {/* Sign up */}
                {/* <p className="mt-6 text-sm text-gray-600 text-center">
                    Don’t have an account?{" "}
                    <a href="#" className="font-medium text-blue-600 hover:underline">
                        Sign up
                    </a>
                </p> */}
            </div>
        </div>
    );
};

export default LoginForm;
